// this file is generated by update_shopify_store_data.py at 2026-03-11 20:29:33.195337
var courses = [];